import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase 환경 변수가 설정되지 않았습니다.');
}

export const supabase = createClient(
  supabaseUrl || '', 
  supabaseAnonKey || '', 
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
    db: {
      schema: 'public',
    },
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
    },
  }
);

// 세션 복구 헬퍼 함수
export const recoverSession = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error) throw error;
    return session;
  } catch (error) {
    console.error('Session recovery failed:', error);
    return null;
  }
};

// 에러 핸들링을 위한 헬퍼 함수
export const handleSupabaseError = (error: any) => {
  if (error?.message?.includes('Failed to fetch')) {
    console.warn('네트워크 연결 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    return;
  }
  console.error('Supabase error:', error);
};

export interface Celebration {
  id: string;
  title: string;
  sender: string;
  celebration_type: string;
  media_url: string;
  media_urls: string[];
  media_type: 'image' | 'video';
  duration: number;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  user_id: string;
  display_start_at: string | null;
  display_end_at: string | null;
  artist_name?: string;
  artwork_name?: string;
  artwork_spec?: string;
  artwork_description?: string;
  artist_description?: string;
  artwork_price?: string;
  purchase_location?: string;
}

export interface Application {
  id: string;
  name: string;
  email: string;
  phone: string;
  event_type: string;
  event_date: string;
  start_time: string | null;
  end_time: string | null;
  message: string;
  media_type: string;
  additional_info: string | null;
  status: 'pending' | 'confirmed' | 'rejected' | 'completed';
  created_at: string;
  updated_at: string;
}

export interface ArtworkInfo {
  artist_name?: string;
  artwork_name?: string;
  artwork_spec?: string;
  artwork_description?: string;
  artist_description?: string;
  artwork_price?: string | number;
  purchase_location?: string;
}
